import { render } from "./VideoModal.vue?vue&type=template&id=196e46ac&scoped=true"
import script from "./VideoModal.vue?vue&type=script&lang=js"
export * from "./VideoModal.vue?vue&type=script&lang=js"

import "./VideoModal.vue?vue&type=style&index=0&id=196e46ac&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196e46ac"]])

export default __exports__